export default {
  data: () => ({
    users: [],
    uploaderUsers: [],
    activeUser: window.user,
    customer: window.user.customer,
    authorised: true,
    unauthorisedMessage: 'Only administrators can view and edit users. Please contact your administrator.',
  }),
  methods: {
    getNormalUsers() {
      // Get all users based on customer
      axios.get(`/api/v1/customer/users?filters=id:eq:${window.user.uuid}:not&user_type=uploader:not`).then((response) => {
        if (response.data) {
          this.users = response.data.data;
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.authorised = false;
        }
      });
    },
    getUploaderUsers() {
      // Get all uploader users based on customer
      axios.get(`/api/v1/customer/users?filters=id:eq:${window.user.uuid}:not&user_type=uploader`).then((response) => {
        if (response.data) {
          this.uploaderUsers = response.data.data;
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.authorised = false;
        }
      });
    },
  },
  mounted() {
    EventBus.$on("delete-user", async (payload) => {
      const res = await this.fireModal(`delete-user`);
      if (res.data.confirm) {
        try {
          await axios.delete(`/api/v1/user/${payload.uuid}`);

          if (payload.is_uploader) {
            this.uploaderUsers = _.filter(this.uploaderUsers, user => user.uuid !== payload.uuid);
          } else {
            this.users = _.filter(this.users, user => user.uuid !== payload.uuid);
          }
          toastr.success('User Deleted');
        } catch (err) {
          toastr.error('Something went wrong. Please try again later.');
        }
      }
    });

    EventBus.$on("user-added", (payload) => {
      if (payload.is_uploader) {
        this.uploaderUsers.unshift(payload);
      } else {
        this.users.unshift(payload);
      }
    });

    EventBus.$on("toggle-active-status", (payload) => {
      let uploader = false;
      let user_index = _.findIndex(this.users, user => user.uuid === payload.uuid);

      if (user_index < 0) {
        user_index = _.findIndex(this.uploaderUsers, user => user.uuid === payload.uuid);
        uploader = true;
      }

      const new_status = !payload.status;

      axios.patch(`/api/v1/user/roles/${payload.uuid}/changeStatus`, {
        status: new_status,
      }).then(() => {
        if (uploader) {
          this.uploaderUsers[user_index].status = new_status;
        } else {
          this.users[user_index].status = new_status;
        }

        if (new_status) {
          toastr.success('User enabled.');
        } else {
          toastr.success('User disabled.');
        }
      }).catch(() => {
        toastr.error("Unable to change status. Please try again later.");
      });
    });
  },

};
